export default function createTypingIndicatorStyle({ paddingRegular }) {
  return {
    paddingBottom: paddingRegular,
    paddingLeft: paddingRegular
  };
}
